import { OwcComponentFooter } from '@one/react';
import styled from 'styled-components';

export const WorkflowFooterLayout = styled(OwcComponentFooter).attrs({
  slot: 'footer',
  'data-testid': 'workflow-footer',
})`
  flex-shrink: 0;

  /* Remove prefix on ODSU component */
  .owc-component-footer__prefix-slot-wrapper {
    display: none;
  }

  owc-button {
    width: 100%;
  }
`;
